/**
 * Transforms a string to title case from pascal, camel, snake, or kebab case.
 */
export function toTitleCase(input: string): string {
  if (input.length === 0) {
    return '';
  }

  let titleCaseString = '';
  let capitalizeNext = true;

  for (const char of input) {
    if (capitalizeNext) {
      titleCaseString += char.toUpperCase();
      capitalizeNext = false;
    } else if (isUpperCase(char) || isNumber(char)) {
      titleCaseString += ` ${char}`;
      capitalizeNext = false;
    } else if (char === ' ' || char === '_' || char === '-') {
      titleCaseString += ' ';
      capitalizeNext = true;
    } else {
      titleCaseString += char.toLowerCase();
    }
  }

  return titleCaseString;
}

function isUpperCase(char: string): boolean {
  return char >= 'A' && char <= 'Z';
}

function isNumber(char: string): boolean {
  return !isNaN(parseInt(char));
}
